import { useQuery } from 'src/graphql';
import { NOTIFICATIONS_QUERY } from 'src/graphql/notification/query';

export default ({ limit = 1000, offset = 0, q = '', withDeleted = false }) =>
  useQuery(NOTIFICATIONS_QUERY, {
    variables: { limit, offset, q, withDeleted },
    fetchPolicy: 'network-only',
  });
